import NavbarAgrega from "./components/navbarAgrega";
import Footer from "../../components/Footer";
import ButtonTop from "src/components/ButtonTop";

import SectionOne from "./components/sectionOne";
/* import SectionTwo from "./components/sectionTwo"; */
import SectionThree from "./components/sectionThree";
import SectionFour from "./components/sectionFour";
import MediaButtonsOrange from "src/components/MediaButtonsOrange";
/* import SectionFive from "./components/sectionFive";
import { useEffect } from "react"; */

function LandingPageTwo() {

  return (
    <div id="landingPageTwo" className="registerPageLayout">
      <NavbarAgrega />
      {/* <MediaButtonsOrange></MediaButtonsOrange> */}
      <ButtonTop></ButtonTop>
      <div className="registerPageWrapper">
        <SectionFour id="contact"></SectionFour>
      </div>
      {/* <SectionThree id="benefits"></SectionThree>   */}
      {/* <SectionOne></SectionOne> */}
      {/* <SectionTwo id="about"></SectionTwo>
      <SectionFive id="fleet"></SectionFive> */}
      <Footer></Footer>
    </div>
  );
}

export default LandingPageTwo;
